import { gql } from '@apollo/client'

export default gql(`
    mutation createAssetCategory($name: String!, $slug: String $module: String $project: String) {
        createAssetCategory(
            input: {
                name: $name
                slug: $slug
            }
            module: $module
            project: $project
        ) {
            id
            name
            slug
            isTransferring
            assetCount
            isError
        }
    }`
)
